import React, { useState, useMemo } from 'react';
import { CircularProgress, Grid, Card, CardContent, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { ImageOff } from "lucide-react";
import { useStyles } from "../../styles.jsx";

const ProductGrid = ({ loadingProducts, errorProducts, products, handlePrice, productClickHandler }) => {
    const styles = useStyles();
    const [imageErrors, setImageErrors] = useState({});

    const handleImageError = (productId) => {
        setImageErrors(prev => ({
            ...prev,
            [productId]: true
        }));
    };

    const renderProductImage = useMemo(() => {
        return (product) => {
            const hasImageError = imageErrors[product.id];
            const hasValidImage = product.foto && product.foto.trim() !== '';

            if (!hasValidImage || hasImageError) {
                return (
                    <div style={{
                        height: 300,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f5f5f5',
                        borderTopLeftRadius: '12px',
                        borderTopRightRadius: '12px',
                        color: '#999'
                    }}>
                        <ImageOff size={80} />
                    </div>
                );
            }

            return (
                <div
                    style={{
                        height: 300,
                        backgroundImage: `url(${product.foto})`,
                        backgroundSize: 'contain',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        borderTopLeftRadius: '12px',
                        borderTopRightRadius: '12px',
                        backgroundColor: '#fff'
                    }}
                    onError={() => handleImageError(product.id)}
                />
            );
        };
    }, [imageErrors]);

    return (
        <Grid container spacing={1} style={{ margin: 0, width: '100%', padding: '16px' }}>
            {
                loadingProducts ? (<CircularProgress />) : (errorProducts ?
                    (<Alert severity="error">{errorProducts}</Alert>) : (
                        products.filter((c) => c.visivel).map((product) => (
                            <Grid item xs={6} key={product.nome} style={{ padding: '8px' }}>
                                <Card
                                    className={styles.card}
                                    style={{
                                        borderRadius: '12px',
                                        width: '100%',
                                        height: '550px',
                                        margin: 0,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        transform: 'translateZ(0)',
                                        willChange: 'transform'
                                    }}
                                    onClick={() => productClickHandler(product)}
                                >
                                    {renderProductImage(product)}
                                    <CardContent style={{
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        padding: '16px'
                                    }}>
                                        <div>
                                            <Typography gutterBottom component="h6" variant="h6" color="textPrimary" style={{
                                                fontWeight: 700,
                                                fontSize: '2.5rem',
                                                lineHeight: '1.2',
                                                marginBottom: '8px',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical'
                                            }}>
                                                {product.nome}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p" style={{
                                                height: '102px',
                                                fontSize: '1.8rem',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 3,
                                                WebkitBoxOrient: 'vertical',
                                                lineHeight: '1.2'
                                            }}>
                                                {product.descricao}
                                            </Typography>
                                        </div>
                                        <Typography variant="subtitle1" color="textPrimary" component="p" style={{
                                            marginTop: '8px',
                                            fontWeight: 'bold',
                                            fontSize: '2rem',
                                            textAlign: 'right'
                                        }}>
                                            {handlePrice(product.preco)}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                    ))
            }
        </Grid>
    );
};

export default React.memo(ProductGrid);
